import FulfillmentServiceImg from './fulfillmentService.webp';

import fulfillmentServicesHeroSectionImg from './fulfillmentServicesHeroSection.webp';
import dropBurryImg from './dropBurry.webp';
import aerialDropsImg from './aerialDrops.webp';
import stormRestorationImg from './stormRestoration.webp';
import installationImg from './installation.webp';
import MDUImg from './MDU.webp';
import troubleCallsImg from './troubleCalls.webp';
import aerialDropsExpertiseImg from './aerialDropsExpertise.webp';
import clientCentricWaterUtilitySolutionsImg from './clientCentricWaterUtilitySolutions.webp';
import dropBurryExpertiseImg from './dropBurryExpertise.webp';
import installationExpertiseImg from './installationExpertise.webp';
import multipleDwellingUnitsImg from './multipleDwellingUnits.webp';
import troubleCallsExpertiseImg from './troubleCallsExpertise.webp';
import fulfillmentServiceImg from './fulfillmentService.webp';

export const fulfillmentServicesHeroSection = (fulfillmentServicesHeroSectionImg as any).src || fulfillmentServicesHeroSectionImg;

export const dropBurry = (dropBurryImg as any).src || dropBurryImg;

export const aerialDrops = (aerialDropsImg as any).src || aerialDropsImg;

export const stormRestoration = (stormRestorationImg as any).src || stormRestorationImg;

export const installation = (installationImg as any).src || installationImg;

export const MDU = (MDUImg as any).src || MDUImg;

export const troubleCalls = (troubleCallsImg as any).src || troubleCallsImg;

export const aerialDropsExpertise = (aerialDropsExpertiseImg as any).src || aerialDropsExpertiseImg;

export const clientCentricWaterUtilitySolutions =
  (clientCentricWaterUtilitySolutionsImg as any).src || clientCentricWaterUtilitySolutionsImg;

export const dropBurryExpertise = (dropBurryExpertiseImg as any).src || dropBurryExpertiseImg;

export const installationExpertise = (installationExpertiseImg as any).src || installationExpertiseImg;

export const multipleDwellingUnits = (multipleDwellingUnitsImg as any).src || multipleDwellingUnitsImg;

export const troubleCallsExpertise = (troubleCallsExpertiseImg as any).src || troubleCallsExpertiseImg;

export const fulfillmentServicesExpertise = (FulfillmentServiceImg as any).src || FulfillmentServiceImg;

export const fulfillmentService = (fulfillmentServiceImg as any).src || fulfillmentServiceImg;
